import {
  UnitOfMeasureAction,
  UnitOfMeasureState,
} from 'store/data/unitOfMeasure';
import { domainUtility } from 'utility';

const initialState: UnitOfMeasureState = { byId: {}, allIds: [] };

const unitOfMeasureReducer = (
  state: UnitOfMeasureState = initialState,
  action: UnitOfMeasureAction,
): UnitOfMeasureState => {
  switch (action.type) {
    case 'data/unitOfMeasure/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/unitOfMeasure/SET':
      return domainUtility.set(state, action.payload);
    case 'data/unitOfMeasure/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/unitOfMeasure/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/unitOfMeasure/SET_DOMAIN':
      return action.payload;
    default:
      return state;
  }
};

export default unitOfMeasureReducer;
